export default function decorate() {
    let args = [].slice.call(arguments),
        Class = args.pop();

    while (args.length) {
        Class = args.pop()(Class);
    }

    return Class;
}
